import { couponActions } from "../../actionTypes";

const initialState = {
	coupon: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case couponActions.CREATE_COUPON: {
			return { ...state, ...initialState };
		}

		case couponActions.CREATE_COUPON_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				coupon: action.payload,
			};
		}

		case couponActions.CREATE_COUPON_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
